module.exports = __webpack_public_path__ + "static/img/ownyourwordsyellow.83e2db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ownyourwordsyellow.png
// module id = pTbD
// module chunks = 1